import getReduxStore from '../../app/redux/getReduxStore';
import type { TaggedToastProps } from '../../toasts/toasts';
import { UIActions } from '../../ui/uiSlice';

const showEditorToast = (content: TaggedToastProps, duration?: number) => {
  const store = getReduxStore();
  store.dispatch(UIActions.pushToast(content, { duration }));
};

export default showEditorToast;
